export default __webpack_public_path__ + "static/1-8343908425249e54bab0088958146483.png";